import { Card } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
import { useContext, useEffect } from 'react';
import { GraficoBar } from './GraficoBar';
import { useInternacionesIniciadoAutorizadoBarraApilada } from '../hooks';
import { InternacionesTramitesContext } from '../context';
dayjs.locale('es'); // activa el idioma español

export const IniciadoAutorizadoAnualBarraApilada = () => {
  const { anualList, anualDate } = useContext(InternacionesTramitesContext);
  const { datosAnualesBarrasApiladas, getDatosAnualesBarrasApiladas } =
    useInternacionesIniciadoAutorizadoBarraApilada({
      anualList,
      anualDate,
    });

  useEffect(() => {
    if (anualList?.length > 0 && anualDate) {
      getDatosAnualesBarrasApiladas();
    }
  }, [anualList, anualDate]);

  return (
    <Card sx={{ px: 3, py: 3, width: '100%', maxWidth: '800px', height: '300px' }}>
      <GraficoBar
        labels={datosAnualesBarrasApiladas?.labels || []}
        datasets={datosAnualesBarrasApiladas?.datasets || []}
        options={{
          plugins: {
            title: {
              text: 'Histórico de autorizaciones ' + dayjs(anualDate).format('YYYY'),
              display: true,
            },
            legend: { position: 'bottom' },
          },
        }}
      />
    </Card>
  );
};
